"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _isNil = _interopRequireDefault(require("lodash/isNil"));
(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();
var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};
var Poller = /*#__PURE__*/function () {
  /**
   * @param {*} context this is passed to onStop and onPoll.
   * @param {number} interval interval to poll in milliseconds
   * @param {function} onStop called when the polling timeout is cleared
   * @param {function} onPoll called after the interval
   */
  function Poller(context, interval, onStop, onPoll) {
    (0, _classCallCheck2.default)(this, Poller);
    this.context = context;
    this.interval = interval;
    this.baseInterval = interval;
    this.onStop = onStop;
    this.onPoll = onPoll;
  }
  (0, _createClass2.default)(Poller, [{
    key: "setOnStop",
    value: function setOnStop(onStop) {
      this.onStop = onStop;
    }
  }, {
    key: "setOnPoll",
    value: function setOnPoll(onPoll) {
      this.onPoll = onPoll;
    }
  }, {
    key: "setInterval",
    value: function setInterval(interval) {
      this.interval = interval;
    }
  }, {
    key: "stop",
    value: function stop() {
      if (!(0, _isNil.default)(this.timerId)) {
        clearTimeout(this.timerId);
        this.timerId = null;
        this.onStop(this.context);
      }
    }
  }, {
    key: "reset",
    value: function reset() {
      this.interval = this.baseInterval;
      this.stop();
      this.startPoll();
    }
  }, {
    key: "startPoll",
    value: function startPoll() {
      var _this = this;
      this.timerId = setTimeout(function () {
        _this.onPoll(_this.context);
      }, this.interval);
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    value: // @ts-ignore
    function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);
  return Poller;
}();
exports.default = Poller;
;
(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;
  if (!reactHotLoader) {
    return;
  }
  reactHotLoader.register(Poller, "Poller", "/builds/audacious-inquiry/portfolio/prompt/prompt-application/clone/components/prompt-client/src/common/poller.js");
})();
;
(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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